import Layout from '@/layout/index.vue';

export default [
  // 用于同路由跳转，做中转
  {
    path: "/redirect",
    component: Layout,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/error/redirect.vue"),
        meta: {
          noCache: true
        }
      },
    ],
  },
  {
    path: "/404",
    name: 'NotFound',
    component: () => import("@/views/error/not-found.vue"),
    meta: {
      title: 'Not Found',
    },
  },
  // vue-router 3.x 不能自动调整路由匹配顺序，所以需将其放在所有路由最后
  {
    path: "/:pathMatch(.*)*",
    redirect: '/404',
  },
]